import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  locationUnitName: Yup.string().required('This field is required.')
})

export const getInitialValues = editItem => {
  return {
    locationUnitName: editItem?.name ?? ''
  }
}
